import Parse from 'parse';

async function logout() {
  await Parse.User.logOut();
}

export default logout;
